import { useAppContext } from '../context/store/app-provider';

export const useIsRamadanDefaultViewExp = () => {
  const { getExperiment } = useAppContext();
  const isRamadanEnabled = getExperiment(
    'BNPL-5427-Subvention-Ramadan-widgets-default-view'
  );

  return !!isRamadanEnabled;
};
